<template>
  <el-table
    ref="multipleTable"
    v-bind="$attrs"
    v-on="$listeners"
    :empty-text="emptyMessage"
    :default-sort = "{prop: 'username', order: 'ascending'}"
    :lazy="true"
  >
    <el-table-column type="selection" />
    <table-row
      :organizationId="organizationId"
      sortable
      :sort-by="sortByUsername"
      prop="username"
      type="username"
      :label="$t('organizations.table.username')"
    />
    <table-row
      sortable
      :sort-by="sortByEmail"
      prop="email"
      type="email"
      :label="$t('organizations.table.user_email')"
    />
    <table-row
      :organizationId="organizationId"
      sortable
      prop="roles"
      type="roles"
      :label="$t('organizations.table.roles')
    "/>
    <table-row type="action" width="250px"/>
  </el-table>
</template>

<script>
  import TableRow from '@/components/common/TableRow'
  import { toLower, propOr, compose } from 'ramda'

  export default {
    props: ['organizationId', 'usersModifiers'],
    components: {
      TableRow
    },
    methods: {
      sortByUsername(row) {
        return compose(
          toLower,
          propOr('', 'username')
        )(row)
      },
      sortByEmail(row) {
        return compose(
          toLower,
          propOr('', 'email')
        )(row)
      }
    },
    computed: {
      emptyMessage() {
        const usersModifiers = this.usersModifiers
        const defaultMessage = 'organizations.table.empty'
        const message = usersModifiers ? `${defaultMessage}_${usersModifiers}` : defaultMessage

        return this.$t(message)
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
